import {FaCircleInfo} from "react-icons/fa6";
import {Link} from "react-router";

export const LimitsWarningBanner = () => (
  <div className="white-block white-block-border d-flex rounded rounded-3 p-3 pe-4 align-items-start gap-2">
    <div className="text-gray-500">
      <FaCircleInfo size="15px" />
    </div>
    <div className="lh-sm">
      Limits shown in this page refer to your main account only, to see full limits please view{" "}
      <Link to="/accounts/account-usage" className="text-black text-decoration-underline">
        Account Usage
      </Link>
      . To add checks to sub accounts please use the main account to add checks and contact support to allocate these
      checks to sub accounts.
    </div>
  </div>
);
